export default __webpack_public_path__ + "static/Image 39-aed1e4872198723a9747535d84785818.png";